import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app/configuration';
/**
 * Generated class for the LivraisonPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-livraison',
  templateUrl: 'livraison.html',
})
export class LivraisonPage {
  
  livraison: any;
  UpdateTask: any;
  headers: any

  constructor(public navCtrl: NavController, public navParams: NavParams, private httpClient : HttpClient, public configuration: AppConfig ) {

    this.livraison = this.navParams.get('livraison') ;
    this.UpdateTask = this.configuration.UpdateTask
    console.log("UpdateTask -> ", this.UpdateTask)

    this.headers = {
      'Content-type':'application/json',
      'x-api-key':this.configuration.xapikey,
      'x-api-secret':this.configuration.xapisecret
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad LivraisonPage');
  }

  Set(set){

    if(set == 'preparation') {
      this.livraison.status = 'PREPARED'
    //  this.httpClient.post("http://127.0.0.1:3000/sms",{phoneNumber: "+33768335546",text:0}).subscribe(data => {})
    //  this.httpClient.post("http://127.0.0.1:3000/sms",{phoneNumber: "+33768335546",text:1}).subscribe(data => {})
    //  this.httpClient.post("http://127.0.0.1:3000/mail",{Cmd:this.livraison.id_commande, tomail: "babakar.wade.31@gmail.com",subject:"Commande Préparé",titre:1,texte:1}).subscribe(data => {}) 
    };
    if(set == 'collect') {
      this.livraison.status = 'PICKED_UP'
    //  this.httpClient.post("http://127.0.0.1:3000/sms",{phoneNumber: "+33768335546",text:2}).subscribe(data => {})
    //  this.httpClient.post("http://127.0.0.1:3000/mail",{Cmd:this.livraison.id_commande, tomail: "babakar.wade.31@gmail.com",subject:"Commande  Collecté",titre:2,texte:2}).subscribe(data => {}) 
      this.httpClient.post("https://api.sandbox.urbantz.com/v2/task/bytaskid/" + this.livraison.taskId,{paymentType:"COD"},{headers: this.headers}).subscribe(data => {}) 
  };
    if(set == 'transport') {
      this.livraison.status = 'DEPARTED'
    //  this.httpClient.post("http://127.0.0.1:3000/sms",{phoneNumber: "+33768335546",text:3}).subscribe(data => {})
    //  this.httpClient.post("http://127.0.0.1:3000/mail",{Cmd:this.livraison.id_commande, tomail: "babakar.wade.31@gmail.com",subject:"Commande  en livraison",titre:3,texte:3}).subscribe(data => {}) 
    };
    if(set == 'livraison') {
      this.livraison.status = 'DELIVERED'
    //  this.httpClient.post("http://127.0.0.1:3000/sms",{phoneNumber: "+33768335546",text:4}).subscribe(data => {})
    //  this.httpClient.post("http://127.0.0.1:3000/mail",{Cmd:this.livraison.id_commande, tomail: "babakar.wade.31@gmail.com",subject:"Commande  livrée",titre:4,texte:4}).subscribe(data => {}) 
    }

    console.log("this.livraison.status ->", this.livraison.status)
  //  this.navCtrl.pop()
    
  }


}



// WEBPACK FOOTER //
// ./src/pages/livraison/livraison.ts